import React, { ReactNode } from 'react';
import { BasicColumn } from './BasicTable';
import { MonthYearValue } from '../../../utils/MonthYear/MonthYearValue';
import { MonthYear } from '../../../utils/MonthYear/monthYear';

export const dateStr = ({ year, month }: MonthYear): string => `${year} - ${month < 10 ? `0${month}` : month}`;

export const customFormatter = (data: any): React.ReactNode | undefined => {
  const isMonthYear = data?.value instanceof Object && data?.value?.length > 0 && 'date' in data.value[0];
  if (isMonthYear) {
    const monthValues = data?.value as MonthYearValue[];
    return (
      <div>
        {monthValues.map(({ date, value }, i) => (
          <span className="flex" key={i}>
            {dateStr(date)} - {value}
          </span>
        ))}
      </div>
    );
  }
  return genericFormatter(data);
};

export const genericFormatter = (data: any): ReactNode | undefined => {
  if (data?.value instanceof Date) {
    return <span>{data.value.toLocaleDateString('en-CA')}</span>;
  }

  return data?.value instanceof Object ? <span>{JSON.stringify(data?.value)}</span> : undefined;
};

export const getColDefs = (
  row: any,
  customFormatter?: (_data: any) => ReactNode | undefined,
  isSort: boolean = true,
): BasicColumn[] => [
  {
    name: 'ID',
    value: 'firebaseId',
    formatter: (data: any) => (
      <div onClick={() => console.log(data?.value)} className="text-blue-600 cursor-pointer hover:underline">
        {data?.value || ''}
      </div>
    ),
  },
  ...(isSort
    ? Object.keys(row)
        .filter((r) => r !== 'firebaseId')
        .sort()
    : Object.keys(row).filter((r) => r !== 'firebaseId')
  ).map((k) => ({ name: k, value: k, formatter: customFormatter || genericFormatter })),
];
